import React, {useEffect, useState} from "react";
import {Form, Formik} from "formik";
import {Autocomplete, Button, Grid, InputLabel, MenuItem, Select, SelectChangeEvent, TextField,} from "@mui/material";
import AvroGenerator from '../../molecules/avroGenerator/AvroGenerator';
import SqlGenerator from '../../molecules/sqlGenerator/SqlGenerator';
import ProgressPopup from '../../molecules/progressPopup/ProgressPopup'
import DataField from "../../atoms/dataField";
import Picker from "../../atoms/picker";
import TriggerRow from "../../molecules/triggerRow";
import cronstrue from 'cronstrue';
import ActionRow from "../../molecules/actionRow";
import EditIcon from "@mui/icons-material/Edit";
import Box from "@mui/material/Box";
import {IFormDropDown, IFormField} from "../../shared/globalTypes";
import DeleteSharpIcon from "@mui/icons-material/DeleteSharp";
import InfoIcon from "@mui/icons-material/Info";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import FormControl from "@mui/material/FormControl";
import Stack from "@mui/material/Stack";
import LoadingButton from "@mui/lab/LoadingButton";
import {DataGrid, GridCellEditCommitParams, useGridApiContext} from "@mui/x-data-grid";
import Skeleton from "@mui/material/Skeleton";
import {useDispatch, useSelector} from "react-redux";
import {
  getAccessControlPendingSelector,
  getAccessControlSelector,
  getSourceSelector,
  getStewardSelector,
} from "../../../store/dataSource/selectors";
import * as extractorDBData from "../../../store/extractor/selectors";
import {
  getPatternsSelector,
  postRetrySchemaUpdatePendingSelector,
  postSchemaExtErrorSelector,
  postSchemaExtPendingSelector
} from "../../../store/extractor/selectors";
import * as extMetadataSelectors from "../../../store/extractor/metaData/selectors";
import {getExtTableMetaDataSelector} from "../../../store/extractor/metaData/selectors";
import * as constants from "../../../constants/_pickerValues";
import * as accessControlDispatch from "../../../store/dataSource/actions";
import {fetchSourceDetailsReq} from "../../../store/dataSource/actions";
import {IAccessControl} from "../../../store/dataSource/types";
import {IExtractorPatterns, LayerType} from "../../../store/extractor/types";
import {IUser} from "../../../store/groups/types";
import {fetchExtTableMetaDataReq} from "../../../store/extractor/metaData/action";
import {
  fetchExtractorDetailReq,
  fetchPatternsReq,
  postCustomExtReset,
  postDBExtReset,
  postRetrySchemaUpdateRequest,
  postSchemaExtRequest,
  putExtractorReset
} from "../../../store/extractor/actions";
import {useParams} from "react-router";
import * as functions from "../../shared/functions";
import {
  getPrivacyClassificationText,
  getPrivacyPayloadText,
  getSecurityClassificationText,
  getSecurityPayloadText
} from "../../shared/functions";
import * as workflows from "../../../store/workFlows/actions";
import ExtractorStatus from "../../molecules/extractorStatus/ExtractorStatus";
import SaveIcon from "@mui/icons-material/Save";
import {getJobListSelector} from "../../../store/timeBasedTrigger/selectors";
import * as jobDispatch from "../../../store/timeBasedTrigger/actions";
import {IJobListParams} from "../../../store/timeBasedTrigger/types";
import * as taskDispatch from "../../../store/eventBasedTrigger/actions";
import * as webhookDispatch from "../../../store/webhooks/actions";
import {IDataEventTaskList, ITaskListParams,} from "../../../store/eventBasedTrigger/types";
import {
  getEventListSelector,
  getEventTaskListSelector,
  getOutboundListSelector,
} from "../../../store/eventBasedTrigger/selectors";
import Back from "../../atoms/backButton";
import {deleteEventsReq} from "../../../store/events/actions";
import {deleteExtJobSchedulesReq} from "../../../store/jobSchedules/action";
import CustomizedDialogs from "../../atoms/modal/customizedDialogs";
import { useNavigate } from "react-router-dom";
import AppConfig from "../../../config/AppConfig";

export interface TableProps {
  submitTablesData?: any;
  mode: string;
}

export interface IConfigureTableFields {
  name: IFormField;
  description: IFormField;
  schemaName: IFormField;
  dataSetName: IFormField;
  layerName: IFormField;
  tableName: IFormField;
  customsql: IFormField;
  path: IFormField;
  regex: IFormField;
  headerRows: IFormField;
  securityClassification: IFormDropDown;
  privacyClassification: IFormDropDown;
  fileType: IFormDropDown;
  dataStewards: IFormDropDown;
  blobContainer: IFormField;
  fieldDelimeter: IFormField;
  manifestFileFlag: IFormField;
  textDelimiter: IFormField;
  escapeChar: IFormField;
  deleteFiles: IFormField;
}

// Trigger Types
export type triggerTypeList = {
  key: number;
  repeat?: string;
  timezone?: string;
  webhook?: string;
};

// Action Types
export type actionTypeList = {
  key: number;
  outboundWebhook?: string;
  headers?: string;
};

// Actions Initial State
export const actionListInitialState = [
  {
    key: Date.now() + 1,
  },
];

export const triggerListInitialState = [
  {
    key: 0
  },
];

let cellEnablePrivacy = false;
let allowLowTreatment = true;
let allowMediumTreatment = false;
let allowHighTreatment = false;

export const EditExtractorForm = (props: TableProps) => {

  // prompt to prevent user from leaving form
  const [changes, setChanges] = useState(false)
  const [avroCode, setAvroCode] = useState('')
  const [sqlCode, setSqlCode] = useState('')

  const { mode, submitTablesData } = props;
  // setting the initial state
  let ConfigureTablesInitialState: IConfigureTableFields = {
    name: { fieldValue: "", isError: false, errorMsg: "", isNumber: false },
    description: {
      fieldValue: "",
      isError: false,
      errorMsg: "",
      isNumber: false,
    },
    schemaName: {
      fieldValue: "",
      isError: false,
      errorMsg: "",
      isNumber: false,
    },
    dataSetName: {
      fieldValue: "",
      isError: false,
      errorMsg: "",
      isNumber: false,
    },
    path: { fieldValue: "", isError: false, errorMsg: "", isNumber: false },
    regex: { fieldValue: "", isError: false, errorMsg: "", isNumber: false },
    customsql: {
      fieldValue: "",
      isError: false,
      errorMsg: "",
      isNumber: false,
    },
    headerRows: {
      fieldValue: "",
      isError: false,
      errorMsg: "",
      isNumber: false,
    },
    blobContainer: {
      fieldValue: "",
      isError: false,
      errorMsg: "",
      isNumber: false,
    },
    fieldDelimeter: {
      fieldValue: "",
      isError: false,
      errorMsg: "",
      isNumber: false,
    },
    manifestFileFlag: {
      fieldValue: "",
      isError: false,
      errorMsg: "",
      isNumber: false,
    },
    privacyClassification: { fieldValue: "", isError: false, errorMsg: "" },
    securityClassification: { fieldValue: "", isError: false, errorMsg: "" },
    dataStewards: { fieldValue: "", isError: false, errorMsg: "" },
    fileType: { fieldValue: "", isError: false, errorMsg: "" },
    layerName: {
      fieldValue: "",
      isError: false,
      errorMsg: "",
      isNumber: false,
    },
    tableName: {
      fieldValue: "",
      isError: false,
      errorMsg: "",
      isNumber: false,
    },
    textDelimiter: {
      fieldValue: "",
      isError: false,
      errorMsg: "",
      isNumber: false,
    },
    escapeChar: {
      fieldValue: "",
      isError: false,
      errorMsg: "",
      isNumber: false,
    },
    deleteFiles: {
      fieldValue: "",
      isError: false,
      errorMsg: "",
      isNumber: false,
    },

  };

  window.addEventListener("beforeunload", (ev) => {
    ev.preventDefault();
    return (ev.returnValue = "Are you sure you want to close?");
  });
  const dispatch = useDispatch();

  // get extractor details
  const extractorDetail = useSelector(
    extractorDBData.getExtractorDetailSelector
  );
  const loadingExtractorDetail = useSelector(
    extractorDBData.getExtractorDetailPendingSelector
  );

  const { batchCode } = useParams();
  useEffect(() => {
    // When batchcode is available, when it is either VIEW or EDIT
    if (props.mode !== constants.MODE.add && batchCode) {
      dispatch(fetchExtractorDetailReq(batchCode));
    }
  }, [batchCode]);

  let AccessControlsInitial: string[] = [constants.IDP_PROD_USERS];
  let DataStewardIDsInitial: IUser[] = [];

  // selectors
  const stewardData = useSelector(getStewardSelector).sort((a, b) => a.userName.toLowerCase().localeCompare(b.userName.toLowerCase()));
  const accessControls = useSelector(getAccessControlSelector);
  const accessControlsPending = useSelector(getAccessControlPendingSelector);
  const patterns = useSelector(getPatternsSelector);

  // state values
  const [displayTriggers, setDisplayTriggers] = useState(false);
  const [displayActions, setDisplayActions] = useState(false);
  const [configureTablesData, setConfigureTablesData] = useState(
    ConfigureTablesInitialState
  );
  const [actions, setActions] = useState(actionListInitialState);
  const [accessControlGroup, setAccessControlGroup] = useState<Array<string>>(
    AccessControlsInitial
  );
  const [dataStewardGroup, setDataStewardGroup] = useState("Not Available");
  const [comparisonKey, setComparisonKey] = useState<Array<string>>([]);
  const [dataStewardIDs, setDataStewardIDs] = useState(DataStewardIDsInitial);
  const [extract, setExtract] = useState<string>("");
  const [staging, setStaging] = useState<string>("-1");
  const [history, setHistory] = useState<string>("");
  const [landing, setLanding] = useState<string>("");
  const [techMetadataChanged, setTechMetadataChanged] = useState(false);
  const [columnGovernance, setColumnGovernance] = useState<any>();
  const [disablePrivacy, setDisablePrivacy] = useState(false);
  const [createdBy, setCreatedBy] = useState("");
  const [createdOn, setCreatedOn] = useState("");
  const [lastModified, setLastModified] = useState("");
  const [lastUpdated, setLastUpdated] = useState("");
  const [s3SchemaSource, setS3SchemaSource] = useState("");
  const [s3Type, setS3Type] = useState("");
  const [s3Name, setS3Name] = useState("");
  const [loader, setLoader] = useState(false);
  const [jobList, setJobList] = useState<any>();
  const [tasks, setTasks] = useState<any>();
  const [eventList, setEventList] = useState<any>();
  const [outbound, setOutbound] = useState<any>();
  const [triggers, setTriggers] = useState(triggerListInitialState);
  const [open, setOpen] = useState(false);
  const [openTimeTrigger, setOpenTimeTrigger] = useState(false);
  const [openOutbound, setOpenOutbound] = useState(false);
  const [sourceId, setSourceId] = useState<any>();
  const [connection, setConnection] = useState("");
  const [layerType, setLayerType] = useState("");
  const [displaySchemaUpdateBtn, setDisplaySchemaUpdateBtn] = useState(false);
  const [displayRetrySchemaBtn, setDisplayRetrySchemaBtn] = useState(false);
  const [displayUpdateEXTBtn, setDisplayUpdateEXTBtn] = useState(false);
  const getDataSource = useSelector(getSourceSelector);
  const updateSchemaPending = useSelector(postSchemaExtPendingSelector);
  const retryUpdateSchemaPending = useSelector(postRetrySchemaUpdatePendingSelector);
  const updateSchemaError = useSelector(postSchemaExtErrorSelector);

  //Get New Schema
  const extractorTableData = useSelector(getExtTableMetaDataSelector);
  const tableName = configureTablesData.name.fieldValue;

  const navigate = useNavigate();

  useEffect(() => {
    if (mode === constants.MODE.edit && extractorDetail) {
      setDisplayRetrySchemaBtn(false);
      configureTablesData.name.fieldValue = extractorDetail?.businessMetadata?.name;
      configureTablesData.description.fieldValue = extractorDetail?.businessMetadata?.description;
      configureTablesData.schemaName.fieldValue = extractorDetail?.businessMetadata?.schema;
      configureTablesData.dataSetName.fieldValue =
          extractorDetail?.businessMetadata?.dataSetName === null
          ? "Not Available"
          : extractorDetail?.businessMetadata?.dataSetName;
      configureTablesData.securityClassification.fieldValue = extractorDetail?.businessMetadata?.securityClassification;
      if (extractorDetail?.businessMetadata?.securityClassification === "confidential") {
        setDisablePrivacy(true)
      }
      configureTablesData.privacyClassification.fieldValue = extractorDetail?.businessMetadata?.privacyClassification;
      configureTablesData.layerName.fieldValue = extractorDetail?.sourceLayer?.name;
      configureTablesData.tableName.fieldValue = extractorDetail?.businessMetadata?.tableName;
      const splitComparisonKeys: string[] =
          extractorDetail?.mappingAttributes ? extractorDetail?.mappingAttributes.split(";") : [];
      setComparisonKey(splitComparisonKeys);
      const steward: IUser[] = [
        {
          userName:
            extractorDetail?.businessMetadata?.dataStewards === null
              ? "Not Available"
              : extractorDetail?.businessMetadata?.dataStewards,
        },
      ];
      setDataStewardIDs(steward);
      setAccessControlGroup(
        extractorDetail?.businessMetadata?.accessControls,
      );
      setExtract(extractorDetail?.extPattern === null ? '-1' : extractorDetail?.extPattern?.selectedPatternId);
      setStaging(extractorDetail?.stgPattern?.selectedPatternId);
      setHistory(extractorDetail?.hstgPattern?.selectedPatternId);
      setLanding(extractorDetail?.lndPattern?.selectedPatternId);
      setSourceId(extractorDetail?.sourceLayer?.id);
      setLastModified(new Date(extractorDetail?.lastModifiedOn).toString());
      setCreatedBy(extractorDetail?.createdBy);
      setLastUpdated(extractorDetail?.lastUpdatedBy);
      setCreatedOn(new Date(extractorDetail?.createdOn).toString());

      configureTablesData.blobContainer.fieldValue = extractorDetail?.fileRegistration?.blobContainer!;
      configureTablesData.fileType.fieldValue = extractorDetail?.fileRegistration?.extension ? extractorDetail?.fileRegistration?.extension.toUpperCase() : '';
      configureTablesData.fieldDelimeter.fieldValue = extractorDetail?.fileRegistration?.fieldDelimeter!;
      configureTablesData.headerRows.fieldValue = extractorDetail?.fileRegistration?.isHeader ? extractorDetail?.fileRegistration?.isHeader.toString().toUpperCase() : 'FALSE';
      configureTablesData.textDelimiter.fieldValue = extractorDetail?.fileRegistration?.textDelimiter!;
      configureTablesData.escapeChar.fieldValue = extractorDetail?.fileRegistration?.escapeChar!;
      configureTablesData.deleteFiles.fieldValue = extractorDetail?.fileRegistration?.deleteFlag!;
      configureTablesData.manifestFileFlag.fieldValue = extractorDetail?.fileRegistration?.manifestFileFlag ?? "FALSE";
      configureTablesData.regex.fieldValue = extractorDetail?.fileRegistration?.wildcardExpression!;
      configureTablesData.customsql.fieldValue = extractorDetail?.customSql === null ? "" : extractorDetail?.customSql;
      const newRows = extractorDetail.columnGovernanceMetadata.sort((a, b) => (a.ordinal > b.ordinal) ? 1 : -1).map(
        (item: any, index: number) => {
          return {
            srcColumnName: item.columnId,
            synColumnName: item.columnId,
            treatmentLevel: functions.capitalizeFirstLetter(item.treatmentLevel),
            securityClassification: getSecurityClassificationText(item.securityClassification),
            privacyClassification: getPrivacyClassificationText(item.privacyClassification),
            id: index,
          };
        }
      );

      setColumnGovernance(newRows);
    } else {
    }
  }, [extractorDetail, mode]);

  useEffect(() => {
    if (mode === constants.MODE.edit && getDataSource) {
      setLayerType(getDataSource["layerType"]);
    }
  }, [getDataSource, mode]);

  useEffect(() => {
    if (mode === constants.MODE.edit && sourceId) {
      dispatch(fetchSourceDetailsReq(Number(sourceId)));
    }
  }, [sourceId, mode]);

  useEffect(() => {
    dispatch(accessControlDispatch.fetchStewardRequest("IDP Users Production"));
    if (!accessControlsPending && accessControls.length <= 0) {
      dispatch(accessControlDispatch.fetchAccessControlRequest());
    }
    if (dataStewardGroup) {
      dispatch(accessControlDispatch.fetchStewardRequest(dataStewardGroup));
    }
    if (sourceId !== undefined) {
      if (connection !== constants.CONNECTION_TYPES.azure && connection !== constants.EXTRACT_TYPES.adls) {
        dispatch(
          fetchPatternsReq({ layerType: LayerType.EXT, sourceId: sourceId })
        );
      }
      dispatch(
        fetchPatternsReq({ layerType: LayerType.LND, sourceId: sourceId })
      );
      dispatch(
        fetchPatternsReq({ layerType: LayerType.HSTG, sourceId: sourceId })
      );

    }
  }, [dataStewardGroup, sourceId]);

  // Populate names for stewards based on selected data steward AD group

  useEffect(() => {
    dispatch(accessControlDispatch.fetchStewardRequest(dataStewardGroup));
    //Sort Data Stewards Group
    accessControls.sort((a, b) => a.groupName.toLowerCase().localeCompare(b.groupName.toLowerCase()));
  }, [dataStewardGroup]);

  // fetch source details to get database type
  useEffect(() => {
    if (sourceId !== undefined) {
      dispatch(accessControlDispatch.fetchSourceDetailsReq(Number(sourceId)));
    }
  }, [sourceId]);

  const sourceDetails = useSelector(getSourceSelector);

  useEffect(() => {
    setConnection(sourceDetails ? sourceDetails?.layerType : "");
  }, [connection]);

  // fetching job and extractor event for triggers
  const params: IJobListParams = {
    taskCode: batchCode ? batchCode : "",
  }
  const eventTaskParams: ITaskListParams = {
    taskType: "Extract_Task",
    taskCode: batchCode,
  };

  const goBack = () => {
    dispatch(postDBExtReset());
    dispatch(putExtractorReset());
    dispatch(postCustomExtReset());
    window.history.back();
    setChanges(false)

  };

  const viewExtractor = (event: React.MouseEvent<HTMLButtonElement>) => {
    const url = `/ViewDataExtractor/${batchCode}`;
    if (event.ctrlKey) {
      window.open(url, '_blank')
    }
    else {
      navigate(url);
    }
  }


  useEffect(() => {
    if (mode === constants.MODE.view || mode === constants.MODE.edit) {
      dispatch(jobDispatch.fetchJobListReq(params));
      dispatch(taskDispatch.fetchEventTaskListReq(eventTaskParams));
    }
  }, []);

  const jobs = useSelector(getJobListSelector);
  const eventTaskList: IDataEventTaskList = useSelector(
    getEventTaskListSelector
  );

  useEffect(() => {
    setTasks(eventTaskList);
  }, [eventTaskList]);

  useEffect(() => {
    setJobList(jobs);
  }, [jobs]);

  // fetching inbound and outbound webhook

  useEffect(() => {
    if (mode === constants.MODE.edit) {

      if (tasks && tasks.length > 0) {
        const eventListParams = {
          eventActionValue: tasks[0].id,
        };

        dispatch(taskDispatch.fetchEventListReq(eventListParams));

        const inboundWebhookParams = {
          eventType: "WEB_HOOK.INBOUND",
          eventActionValue: tasks && tasks.length > 0 && tasks[0].id,
        };

        const outboundWebhookParams = {
          eventAction: "CALL_WEB_HOOK",
          eventQualifier: tasks && tasks.length > 0 && tasks[0].id,
        };

        dispatch(taskDispatch.fetchInboundListReq(inboundWebhookParams));
        dispatch(taskDispatch.fetchOutboundListReq(outboundWebhookParams));
      }

    }
  }, [tasks]);

  // returns all events (includes inbound and extractor based triggers)
  const getEvents = useSelector(getEventListSelector);
  const outboundList = useSelector(getOutboundListSelector);

  useEffect(() => {
    setOutbound(outboundList);
  }, [outboundList]);

  useEffect(() => {
    setEventList(getEvents);
  }, [getEvents]);

  // adding treatment, security classification, privacy classification fields to column governance data
  const tableInfo = {
    layer_id: sourceId,
    schema: configureTablesData?.schemaName.fieldValue,
    table_name: (mode === constants.MODE.add) ? configureTablesData?.name.fieldValue : configureTablesData.tableName.fieldValue,
  };

  useEffect(() => {
    if (mode === constants.MODE.add) {
      dispatch(fetchExtTableMetaDataReq(tableInfo));
    }
  }, []);

  useEffect(() => {
    if (updateSchemaError?.errorCode !== undefined) {
      setDisplayRetrySchemaBtn(true);
      setDisplaySchemaUpdateBtn(false);
    }
  }, [updateSchemaError])

  // generate column governance fields
  useEffect(() => {
    if (extractorTableData[tableName]) {
      const newRows = extractorTableData[tableName]?.map(
        (item: any, index: number) => {
          return {
            ...item,
            treatmentLevel: "None",
            securityClassification: "None",
            privacyClassification: "None",
            id: index,
          };
        }
      );
      setColumnGovernance(newRows);
    }
    if (mode === "Edit" && extractorTableData[configureTablesData.dataSetName.fieldValue]) {
      const newRows = extractorTableData[configureTablesData.dataSetName.fieldValue]?.map(
        (item: any, index: number) => {
          //Prepopulate the security/Privacy based on old schema
          let treatmentValue = extractorDetail?.columnGovernanceMetadata.find(x => x.columnId === item.srcColumnName)?.treatmentLevel!;
          let securityValue = extractorDetail?.columnGovernanceMetadata.find(x => x.columnId === item.srcColumnName)?.securityClassification!;
          let privacyValue = extractorDetail?.columnGovernanceMetadata.find(x => x.columnId === item.srcColumnName)?.privacyClassification!;

          if (treatmentValue === undefined) {
            if (extractorDetail?.businessMetadata.securityClassification === 'highly_confidential') {
              treatmentValue = 'high'
              securityValue = constants.SECURITY_CLASS.highlyConfidential
              privacyValue = extractorDetail.businessMetadata.privacyClassification
            } else if (extractorDetail?.businessMetadata.securityClassification === 'confidential') {
              securityValue = constants.SECURITY_CLASS_VALUES.confidential;
              if (extractorDetail?.businessMetadata.privacyClassification === 'none') {
                treatmentValue = 'medium'
                privacyValue = constants.PRIVACY_CLASS_VALUES.none
              } else if (extractorDetail?.businessMetadata.privacyClassification === 'personal') {
                treatmentValue = 'high'
                privacyValue = constants.PRIVACY_CLASS_VALUES.personal
              } else if (extractorDetail?.businessMetadata.privacyClassification === 'sensitive') {
                treatmentValue = 'very-high'
                privacyValue = constants.PRIVACY_CLASS_VALUES.sensitive
              }
            }
            else {
              treatmentValue = 'low';
              securityValue = constants.SECURITY_CLASS_VALUES.general;
              privacyValue = constants.PRIVACY_CLASS_VALUES.none;
            }
          }
          return {
            ...item,
            treatmentLevel: functions.capitalizeFirstLetter(treatmentValue),
            securityClassification: getSecurityClassificationText(securityValue),
            privacyClassification: getPrivacyClassificationText(privacyValue),
            id: index,
          };
        }
      );
      setColumnGovernance(newRows);
    }
  }, [extractorTableData]);

  //Get new Schema
  const generateFieldsFromDB = () => {
    dispatch(fetchExtTableMetaDataReq(tableInfo));
    setDisplaySchemaUpdateBtn(true);
    setDisplayUpdateEXTBtn(true);
    setDisplayRetrySchemaBtn(false);
  }

  const updateSchema = () => {

    //logic to dispatch the update schema
    const hstgKeyCS: string = (configureTablesData.customsql.fieldValue !== "" && layerType === constants.EXTRACT_TYPES.mssql) ? "CS_" : ""
    const tableKey = `HSTG_${configureTablesData.layerName.fieldValue}_${configureTablesData.schemaName.fieldValue}_${hstgKeyCS}${configureTablesData.dataSetName.fieldValue}_SK`.toUpperCase()
    const hstgKey = {
      "id": "-1",
      "srcColumnName": tableKey,
      "srcDataType": "varchar",
      "srcMaxLength": -1,
      "srcOrdinal": 0,
      "srcPrecision": 0,
      "srcScale": 0,
      "synColumnName": `HSTG_${configureTablesData.layerName.fieldValue}_${configureTablesData.schemaName.fieldValue}_${configureTablesData.dataSetName.fieldValue}_SK`,
      "synDataType": "VARCHAR",
      "synMaxLength": "100",
      "synOrdinal": "0",
      "synPrecision": "",
      "synScale": "",
      "treatmentLevel": 'low',
      "privacyClassification": "None",
      "securityClassification": "General Business"
    }
    const newConfigureTBLData = Object.assign([], columnGovernance);
    newConfigureTBLData.push(hstgKey);

    if (configureTablesData.customsql.fieldValue === "") {
      const governanceData = newConfigureTBLData.map((item: any) => {
        return {
          columnId: item.srcColumnName, "privacyClassification": getPrivacyPayloadText(item.privacyClassification),
          "securityClassification": getSecurityPayloadText(item.securityClassification), "treatmentLevel": item.treatmentLevel.toLowerCase(),
          "manualTreatment": 's', "ordinal": item.srcOrdinal
        };
      });

      let keys = columnGovernance.map((x: { srcColumnName: string; }) => x.srcColumnName);
      if (keys.join(';') !== extractorDetail?.mappingAttributes) {
         setTechMetadataChanged(true)
      }
      setComparisonKey(keys);

      let mappingAttributeData = keys.length > 0 ? keys.join(';') : null;

      let schemaMetadata = {
        columnGovernanceMetadata: governanceData,
        mappingAttributes: mappingAttributeData!
      }

      dispatch(postSchemaExtRequest(batchCode!, schemaMetadata));
    }
    else {

      const customsqlgovernanceMetadata = newConfigureTBLData.map((item: any) => {
        return {
          columnId: item.srcColumnName, "privacyClassification": getPrivacyPayloadText(item.privacyClassification),
          "securityClassification": getSecurityPayloadText(item.securityClassification), "treatmentLevel": item.treatmentLevel.toLowerCase(),
          "manualTreatment": 's', "ordinal": item.srcOrdinal
        };
      });

      let keys = columnGovernance.map((x: { srcColumnName: string; }) => x.srcColumnName);
      if (keys.join(';') !== extractorDetail?.mappingAttributes) {
         setTechMetadataChanged(true)
      }
      setComparisonKey(keys);
      let mappingAttributeData = keys.length > 0 ? keys.join(';') : null;

      const customTableData = columnGovernance?.map((item: any) => {
        return {
          "name": item.srcColumnName,
          "dataType": item.srcDataType !== undefined ? item.srcDataType.toString() : '',
          "maxLength": isNaN(parseFloat(item.srcMaxLength)) ? 0 : parseFloat(item.srcMaxLength),
          "precision": item.srcPrecision !== "" ? Number(item.srcPrecision) : 0,
          "scale": item.srcScale !== "" ? Number(item.srcScale) : 0,
          "ordinalPosition": item.srcOrdinal
        };
      });

      let fileRegistration = {
        "blobContainer": configureTablesData.blobContainer.fieldValue === null ? "" : configureTablesData.blobContainer.fieldValue,
        "fieldDelimeter": configureTablesData.fieldDelimeter.fieldValue === null ? "" : configureTablesData.fieldDelimeter.fieldValue,
        "extension": configureTablesData.fileType.fieldValue,
        "isHeader": configureTablesData.headerRows.fieldValue === "true",
        "manifestFileFlag": configureTablesData.manifestFileFlag.fieldValue,
        "wildcardExpression": configureTablesData.regex.fieldValue === null ? "" : configureTablesData.regex.fieldValue,
        "fileName": configureTablesData.dataSetName.fieldValue,
        "folderName": configureTablesData.schemaName.fieldValue
      }

      let schemaMetadata = {
        columnGovernanceMetadata: customsqlgovernanceMetadata,
        mappingAttributes: mappingAttributeData!,
        customSql: configureTablesData.customsql.fieldValue,
        columns: customTableData,
        fileRegistration: fileRegistration
      }

      dispatch(postSchemaExtRequest(batchCode!, schemaMetadata));
    }
    setDisplaySchemaUpdateBtn(false);
  }

  const retrySchemaUpdate = () => {
    dispatch(postRetrySchemaUpdateRequest(batchCode!, true));
    setDisplaySchemaUpdateBtn(false);
    setDisplayRetrySchemaBtn(false);
  }

  useEffect(() => {
    if (!retryUpdateSchemaPending && !updateSchemaPending) {
      setDisplayUpdateEXTBtn(false);
    }
    else {
      setDisplayUpdateEXTBtn(true);
    }

  }, [updateSchemaPending, retryUpdateSchemaPending])

  // handle text field changes
  const handleCommit = (e: GridCellEditCommitParams) => {
    const array = columnGovernance.map((row: any) => {
      if (row.id === e.id) {
        return { ...row, [e.field]: e.value };
      } else {
        return { ...row };
      }
    });
    setColumnGovernance(array);
  };

  // onchange for data stewards
  const updateDataStewardGroup = (event: SelectChangeEvent<string>) => {
    let value: string = event.target.value;
    setDataStewardGroup(value);
  };

  // set pending when add set button clicked
  const pending = useSelector(extractorDBData.putExtractorPendingSelector);
  const pendingMetadata = useSelector(extMetadataSelectors.putMetadataPendingSelector);

  //error validation for dropdowns

  const [error, setError] = useState(false);
  const [required, setRequired] = useState(true);
  const errorMsg = "Field is required";

  const onHandleBlur = (event: {}) => {
    const e = event as React.FocusEvent<HTMLInputElement>;
    (e.target.value === "" || !e.target.value) && required
      ? setError(true)
      : setError(false);
  };

  const errorStyle = {
    color: "#d32f2f",
    fontSize: "small",
    paddingTop: "1em",
  };
  // onchange for textfields
  const handleChange = (event: {}) => {
    const e = event as React.ChangeEvent<HTMLInputElement>;
    let field: IFormField = {
      fieldValue: e.currentTarget.value,
      isError: false,
      errorMsg: "",
      isNumber: false,
    };

    setConfigureTablesData({ ...configureTablesData, [e.target.name]: field });
    setChanges(true)
  };

  const cascadeFieldSecurity = (security: string, privacy: string) => {
    let treatmentLevel = 'low'

    if (security === 'highly_confidential') {
      treatmentLevel = 'high'
    } else if (security === 'confidential') {
      if (privacy === 'none') {
        treatmentLevel = 'medium'
      } else if (privacy === 'personal') {
        treatmentLevel = 'high'
      } else if (privacy === 'sensitive') {
        treatmentLevel = 'very-high'
      }
    }

    security = getSecurityClassificationText(security)!;
    privacy = getPrivacyClassificationText(privacy)!

    const array = columnGovernance.map((row: any) => {
      return { ...row, treatmentLevel: treatmentLevel, securityClassification: security, privacyClassification: privacy }
    });

    setColumnGovernance(array);
  }

  //security / privacy classification
  const updateSecurityDropdown = (event: SelectChangeEvent<string>) => {

    let value: string = event.target.value;

    if (value !== 'confidential') {
      setDisablePrivacy(false);
      setConfigureTablesData({
        ...configureTablesData, [event.target.name]: functions.getFormField(value),
        privacyClassification: functions.getFormField('none')
      });
      cascadeFieldSecurity(value, 'none')
    } else {
      setDisablePrivacy(true);
      setConfigureTablesData({ ...configureTablesData, [event.target.name]: functions.getFormField(value) });
      cascadeFieldSecurity(value, configureTablesData.privacyClassification.fieldValue)
    }
    setChanges(true)

  };

  const updatePrivacyDropdown = (event: SelectChangeEvent<string>) => {

    let value: string = event.target.value;

    setConfigureTablesData({ ...configureTablesData, [event.target.name]: functions.getFormField(value) });

    cascadeFieldSecurity(configureTablesData.securityClassification.fieldValue, value)
    setChanges(true)

  };


  const runWorkflow = () => {
    const finalExtractorRun = {
      batchCode: batchCode ? batchCode : "",
      rebase: false,
    };
    dispatch(workflows.postWorkFlowsRequest(finalExtractorRun));
  };

  const runRebase = () => {
    const finalExtractorRun = {
      batchCode: batchCode ? batchCode : "",
      rebase: true,
    };
    dispatch(workflows.postWorkFlowsRequest(finalExtractorRun));
  };

  // onchange for dropdown
  const handleDropDownChange = (e: SelectChangeEvent<string>) => {
    let field: IFormDropDown = {
      fieldValue: e.target.value,
      isError: false,
      errorMsg: "",
    };

    setConfigureTablesData({ ...configureTablesData, [e.target.name]: field });
    setChanges(true)
  };

  // onchange for trigger
  const onTriggerChange = (inputTrigger: triggerTypeList) => {
    const newTriggers = triggers.map((item: any) => {
      if (item.key === inputTrigger.key) return inputTrigger;
      return item;
    });
    setTriggers(newTriggers);
  };

  // add new trigger
  const addTrigger = () => {
    setTriggers(
      triggers.concat({
        key: Date.now(),
      })
    );
  };

  const editTimeTrigger = (item: any) => {
    setTriggers(
      triggers.concat({
        key: Date.now(),
        ...item,
        edit: true,
      })
    );
  };

  // edit trigger
  const editExtractor = (item: any) => {
    setTriggers(
      triggers.concat({
        key: Date.now(),
        ...item,
        edit: true,
      })
    );
  };

  const editOutbound = (item: any) => {
    setActions(
      actions.concat({
        key: Date.now(),
        ...item,
        edit: true,
      })
    );
  };

  // delete trigger
  const deleteTrigger = (id: number) => {
    const triggerItem = triggers.filter((item: any) => item.key !== id);
    setTriggers(triggerItem);
  };

  const handleClose = () => {
    setOpen(false);
    setOpenOutbound(false);
    setOpenTimeTrigger(false);
  };

  const onDropdownChange = (e: SelectChangeEvent<string>) => {
    setConfigureTablesData({
      ...configureTablesData,
      [e.target.name]: functions.getFormField(e.target.value),
    });
    setTechMetadataChanged(true);
  };

  // onchange for action
  const onActionChange = (inputAction: actionTypeList) => {
    const newActions = actions.map((item) => {
      if (item.key === inputAction.key) return inputAction;
      return item;
    });
    setActions(newActions);
  };

  // add new action
  const addAction = () => {
    setActions(
      actions.concat({
        key: Date.now(),
      })
    );
  };

  // delete action
  const deleteAction = (id: number) => {
    const actionItem = actions.filter((item) => item.key !== id);
    setActions(actionItem);
  };

  const handleExtractorDelete = (item: any) => {
    setOpen(false);
    dispatch(deleteEventsReq(item));
  };

  const handleOutboundDelete = (item: any) => {
    setOpenOutbound(false);
    dispatch(webhookDispatch.deleteOutboundWebhookReq(item));
  };

  const handleJobDelete = (item: any) => {
    setOpenTimeTrigger(false);
    dispatch(deleteExtJobSchedulesReq(item));
  };

  // Validating individual form UI on the accordion on clicking Save Settings
  const validateForm = () => {
    //first check if amazon s3 form fields are empty
    if (connection === "S3 Buckets" || connection === "Windows Fileshare") {
      if (
        !configureTablesData.path.fieldValue ||
        !configureTablesData.regex.fieldValue ||
        !configureTablesData.headerRows.fieldValue
      )
        return alert(
          "Please make sure to fill required Amazon S3 fields in table " +
          configureTablesData.name.fieldValue
        );
    }
    const database = connection;

    // then check if other form fields are empty
    if (
      !configureTablesData.name.fieldValue ||
      !configureTablesData.description.fieldValue ||
      !configureTablesData.schemaName.fieldValue ||
      !configureTablesData.privacyClassification.fieldValue ||
      !configureTablesData.securityClassification.fieldValue
    ) {
      alert(
        "Please make sure to fill required fields in table " +
        configureTablesData.name.fieldValue
      );
    } else {
      const dataSteward = dataStewardIDs
        ?.map(({ userName }) => `${userName}`)
        .join(", ");

      let gov = columnGovernance.map((x: any) => {
        return {
          ...x,
          securityClassification: getSecurityPayloadText(x.securityClassification!),
          privacyClassification: getPrivacyPayloadText(x.privacyClassification!)
        }
      })

      let tableData = {
        configureTablesData,
        columnGovernance: gov,
        extract,
        history,
        staging,
        landing,
        accessControlGroup,
        dataSteward,
        triggers,
        actions,
        database,
        connection,
        comparisonKey,
        s3SchemaSource,
        s3Type,
        s3Name,
        layerType,
        batchCode,
        eventTask: tasks,
        techMetadataChanged
      };
      submitTablesData(tableData);
      setLoader(true);
    }
  };

  useEffect(() => {
      if (!pending && !pendingMetadata && loader) {
        setDisplayUpdateEXTBtn(true);
      }
    }, [pending, pendingMetadata,loader]
  );

  useEffect(() => {
    setDisplayTriggers(true);
  }, [displayTriggers]);

  useEffect(() => {
    setDisplayActions(true);
  }, [displayActions]);

  useEffect(() => {
    setDisplayTriggers(false);
    setDisplayActions(false);
  }, []);
  const getAvroCode = (code: string) => {
    try {
      const getAvroValue = JSON.parse(code)
      const newRows = getAvroValue.fields?.map((item: any, index: number) => {
        let precision = 0
        let scale = 0
        if (item.unmodified_size && item.unmodified_size.includes(',')) {
          precision = item.unmodified_size.split(',')[0]
          scale = item.unmodified_size.split(',')[1]
        }
        return {
          ...item, srcColumnName: item.unmodified_name, srcDataType: item.unmodified_type ? item.unmodified_type : item.unmodified_type[0], srcMaxLength: item.unmodified_size ? (item.unmodified_size.includes(',') ? "" : item.unmodified_size) : "",
          srcPrecision: precision, srcScale: scale, synPrecision: precision, synScale: scale,
          synColumnName: item.name, synDataType: item.type ? item.type : item.type[0], synMaxLength: item.size ? item.size : (item.unmodified_size ? (item.unmodified_size.includes(',') ? "" : item.unmodified_size) : 0), treatmentLevel: 'Low', securityClassification: 'General Business', privacyClassification: 'None', id: index, srcOrdinal: index
        };
      });
      setColumnGovernance(newRows)
      setS3SchemaSource(getAvroValue.source ? getAvroValue.source : '')
      setS3Type(getAvroValue.type ? getAvroValue.type : '')
      setS3Name(getAvroValue.name ? getAvroValue.name : '')

    }
    catch (e) {
      alert('Please check the format')
    }

  }

  return (
    <Formik initialValues={{}} onSubmit={() => { }}>
      <div>
        <Back title="Extractor List" />
        <h1>{mode !== "Add" ? extractorDetail?.businessMetadata?.name : ""}</h1>
        <Form>
          {/* adding skeleton screen on loading */}
          {loadingExtractorDetail ? (
            <Box>
              <Grid container spacing={4}>
                <Grid item xs={6}>
                  <Skeleton animation="wave" height={60} />
                </Grid>
                <Grid item xs={6}>
                  <Skeleton animation="wave" height={60} />
                </Grid>
                <Grid item xs={4}>
                  <Skeleton animation="wave" height={60} />
                </Grid>
                <Grid item xs={4}>
                  <Skeleton animation="wave" height={60} />
                </Grid>
                <Grid item xs={4}>
                  <Skeleton animation="wave" height={60} />
                </Grid>
                <Grid item xs={6}>
                  <Skeleton animation="wave" height={60} />
                </Grid>
                <Grid item xs={6}>
                  <Skeleton animation="wave" height={60} />
                </Grid>
                <Grid item xs={12}>
                  <Skeleton animation="wave" height={60} />
                </Grid>
                <Grid item xs={6}>
                  <Skeleton animation="wave" height={60} />
                </Grid>
                <Grid item xs={6}>
                  <Skeleton animation="wave" height={60} />
                </Grid>
                <Grid item xs={6}>
                  <Skeleton animation="wave" height={60} />
                </Grid>
                <Grid item xs={6}>
                  <Skeleton animation="wave" height={60} />
                </Grid>
              </Grid>
            </Box>
          ) : (
            <Grid container spacing={4}>
              <Grid item xs={6}>
                <FormControl sx={{ m: 1 }} fullWidth>
                  <DataField id="72c1360a-f01c-4ec6-8c4d-b9118ad9b5f5"
                    label="Name"
                    name="name"
                    required={true}
                    value={configureTablesData.name.fieldValue}
                    error={configureTablesData.name.isError}
                    onChange={handleChange}
                    disabled
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl sx={{ m: 1 }} fullWidth>
                  <DataField id="de602244-9a44-4b17-af32-32c9826fc09a"
                    label={connection === "S3 Buckets" || layerType === "EXTRACT_S3" || layerType === constants.EXTRACT_TYPES.adls ? layerType === constants.EXTRACT_TYPES.adls ? 'File Name Prefix' : 'File Name' : 'Data Set Name'}
                    name="tableName"
                    required={true}
                    value={configureTablesData.tableName.fieldValue}
                    error={configureTablesData.tableName.isError}
                    onChange={handleChange}
                    disabled
                  />
                </FormControl>
              </Grid>
              <Grid item xs={7}>
                <FormControl sx={{ m: 1 }} fullWidth>
                  <DataField id="bce11f74-0689-45f9-a732-53e6fc550905"
                    type="textarea"
                    name="description"
                    label="Description"
                    required={true}
                    value={configureTablesData.description.fieldValue}
                    error={configureTablesData.description.isError}
                    onChange={handleChange}
                    multiline={true}
                    disabled={mode === constants.MODE.view}
                  />
                </FormControl>
              </Grid>
              {connection === "S3 Buckets" ||
                connection === "Windows Fileshare" ? (
                ""
              ) : (
                <>
                  <Grid item xs={5}>
                    <FormControl sx={{ m: 1 }} fullWidth>
                      <DataField id="6bf572a5-0e95-499c-9cc3-ec98af81579f"
                        label={(() => {
                          if (layerType === constants.EXTRACT_TYPES.s3Buckets) {
                            return 'File Name';
                          } else if (layerType === constants.EXTRACT_TYPES.adls) {
                            return 'File Name Prefix';
                          } else {
                            return 'Data Set Name';
                          }
                        })()}
                        name="schemaName"
                        value={configureTablesData.schemaName.fieldValue}
                        disabled
                        error={configureTablesData.schemaName.isError}
                        onChange={handleChange}
                        required={true}
                      />{" "}
                    </FormControl>
                  </Grid>
                </>
              )}

              <Grid item xs={6}>
                <FormControl sx={{ m: 1 }} fullWidth>
                  <InputLabel htmlFor="accessControls">
                    Access Controls
                  </InputLabel>
                  <Select
                    name="accessControls"
                    label="Access Controls"
                    multiple
                    value={accessControlGroup.map(value => value.toLowerCase())}
                    onChange={(event: any) => {
                      let v = event.target.value as string[];
                      setAccessControlGroup(v);
                    }}
                    labelId="accessControlslabel"
                    fullWidth
                    required
                    disabled={mode === constants.MODE.view}
                    sx={{ textAlign: "left" }}
                  >
                    {accessControls.map(
                      (
                        item: IAccessControl,
                        index: number
                      ) => {
                        return (
                          <MenuItem key={index} value={item.groupName.toLowerCase()}>
                            {item.groupName}
                          </MenuItem>
                        );
                      }
                    )}

                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={6}>
                {/* <FormHelperText>
                  First select Data Stewards group then search for Data Stewards
                </FormHelperText> */}
                <FormControl sx={{ m: 1 }} fullWidth>
                  <InputLabel htmlFor="dataStewardADlabel">
                    Data Stewards Group
                  </InputLabel>
                  <Select
                    name="dataStewardsAD"
                    onChange={updateDataStewardGroup}
                    label="Data Stewards"
                    labelId="dataStewardADlabel"
                    fullWidth
                    disabled={mode === constants.MODE.view}
                    value={dataStewardGroup.toLowerCase()}
                    sx={{ textAlign: "left" }}
                  >
                    {accessControls.map(
                      (
                        item: IAccessControl,
                        index: number
                      ) => {
                        return (
                          <MenuItem key={index} value={item.groupName.toLowerCase()}>
                            {item.groupName}
                          </MenuItem>
                        );
                      }
                    )}

                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={6}>
                <FormControl sx={{ m: 1 }} fullWidth>

                  <Autocomplete
                    multiple
                    options={stewardData}
                    onChange={(event: any, value: any) => {
                      let v = value as IUser[];
                      setDataStewardIDs(v);
                    }}
                    getOptionLabel={(option: any) =>
                      option === undefined ? "" : option.userName
                    }
                    value={dataStewardIDs}
                    renderInput={(params: any) => (
                      <TextField
                        {...params}
                        name="Data Stewards"
                        label="Data Stewards"
                        required
                        value={dataStewardIDs}
                        error={configureTablesData.dataStewards.isError}
                      />
                    )}
                  />
                </FormControl>
              </Grid>

                <Grid item xs={6}>
                <FormControl
                  sx={{ m: 1 }}
                  fullWidth
                  required={required}
                  error={error}
                >
                  <InputLabel htmlFor="securityClassification">
                    Security Classification
                  </InputLabel>
                  <Select
                    id="securityClassification"
                    name="securityClassification"
                    labelId="securityClassification"
                    label="Security Classification"
                    value={
                      configureTablesData.securityClassification.fieldValue
                    }
                    onChange={updateSecurityDropdown}
                    sx={{ textAlign: "left" }}
                    onBlur={onHandleBlur}
                    fullWidth
                  >
                    <MenuItem key={0} value={constants.SECURITY_CLASS_VALUES.general}>
                      {constants.SECURITY_CLASS.general}
                    </MenuItem>
                    <MenuItem key={1} value={constants.SECURITY_CLASS_VALUES.confidential}>
                      {constants.SECURITY_CLASS.confidential}
                    </MenuItem>
                    <MenuItem key={2} value={constants.SECURITY_CLASS_VALUES.highlyConfidential}>
                      {constants.SECURITY_CLASS.highlyConfidential}
                    </MenuItem>
                  </Select>
                  <span style={errorStyle}>{error ? errorMsg : ""}</span>
                </FormControl>
              </Grid>
                <Grid item xs={3}>
                <FormControl
                  sx={{ m: 1 }}
                  fullWidth
                  required={required}
                  error={error}
                >
                  <InputLabel htmlFor="privacyClassification">
                    Privacy Classification
                  </InputLabel>
                  <Select
                    id="privacyClassification"
                    name="privacyClassification"
                    label="Privacy Classification"
                    labelId="privacyClassification"
                    value={configureTablesData.privacyClassification.fieldValue}
                    onChange={updatePrivacyDropdown}
                    onBlur={onHandleBlur}
                    sx={{ textAlign: "left" }}
                    fullWidth
                  >
                    <MenuItem key={0} value={constants.PRIVACY_CLASS_VALUES.none}>
                      {constants.PRIVACY_CLASS.none}
                    </MenuItem>
                    {disablePrivacy && (
                      <MenuItem key={1} value={constants.PRIVACY_CLASS_VALUES.personal}>
                        {constants.PRIVACY_CLASS.personal}
                      </MenuItem>
                    )}
                    {disablePrivacy && (
                      <MenuItem key={2} value={constants.PRIVACY_CLASS_VALUES.sensitive}>
                        {constants.PRIVACY_CLASS.sensitive}
                      </MenuItem>
                    )}
                  </Select>
                  <span style={errorStyle}>{error ? errorMsg : ""}</span>
                </FormControl>
                </Grid>


              <Grid item xs={12}>
                <h2>Patterns</h2>
                <p style={{ color: "red" }}>
                  {" "}
                    {patterns && patterns.EXT === undefined && layerType !== constants.EXTRACT_TYPES.adls
                    ? "Patterns could not be loaded"
                    : ""}
                </p>
              </Grid>
              {patterns && (
                <>
                  <Grid item xs={4}>
                    <FormControl
                      sx={{ m: 1 }}
                      fullWidth
                      required={required}
                      error={error}
                    >
                      <InputLabel htmlFor="extract">Extract</InputLabel>
                      <Select
                        name="extract"
                        label="Extract"
                        value={extract}
                        onChange={(event: any) => {
                          let v = event.target.value;
                          if (v !== extractorDetail?.extPattern?.selectedPatternId) {
                            setTechMetadataChanged(true);
                          }
                          setExtract(v);
                        }}
                        labelId="extractLabel"
                        fullWidth
                        onBlur={onHandleBlur}
                        required
                        disabled={mode === constants.MODE.view}
                        sx={{ textAlign: "left" }}
                      >
                          {patterns.EXT !== undefined &&
                            patterns?.EXT.filter(
                              (item: IExtractorPatterns) => {
                                if (layerType === constants.EXTRACT_TYPES.s3Buckets) {
                                  return item.patternName.includes(
                                    "ADB S3"
                                  );
                                } else return item.patternName;
                              }
                            ).map(
                            (
                              item: IExtractorPatterns,
                              index: number
                            ) => {
                              return (
                                <MenuItem key={index} value={item.etlPatternId}>
                                  {item.patternName}
                                </MenuItem>
                              );
                            }
                          )}
                        <MenuItem value="-1" selected>None</MenuItem>
                      </Select>
                      <span style={errorStyle}>{error ? errorMsg : ""}</span>
                    </FormControl>
                  </Grid>
                  {
                    layerType !== constants.EXTRACT_TYPES.foundry ?
                      <Grid item xs={4}>
                        <FormControl
                          sx={{ m: 1 }}
                          fullWidth
                          required={required}
                          error={error}
                        >
                          <InputLabel htmlFor="landing">Landing</InputLabel>
                          <Select
                            name="landing"
                            label="Landing"
                            value={landing}
                            onChange={(event: any) => {
                              let v = event.target.value;
                              if(v !== extractorDetail?.lndPattern?.selectedPatternId) {
                                setTechMetadataChanged(true);
                              }
                              setLanding(v);
                            }}
                            labelId="landingLabel"
                            fullWidth
                            onBlur={onHandleBlur}
                            disabled={mode === constants.MODE.view}
                            required
                            sx={{ textAlign: "left" }}
                          >
                            {
                              patterns.LND !== undefined &&
                              patterns?.LND.filter(
                                (item: IExtractorPatterns) => {
                                  if (layerType === constants.EXTRACT_TYPES.adls) {
                                    return (item.patternName.includes("RIO-LND ADLS CSV to Synapse")
                                      && !item.patternName.includes("RIO-LND ADLS to ADF Synapse Copy"));
                                  } else return !item.patternName.includes("RIO-LND ADLS to ADF Synapse Copy");
                                }
                              ).map((item: IExtractorPatterns, index: number) => {
                                return (
                                  <MenuItem key={index} value={item.etlPatternId}>{item.patternName}</MenuItem>
                                );
                              })
                            }
                            <MenuItem value="-1" selected>None</MenuItem>
                          </Select>
                          <span style={errorStyle}>{error ? errorMsg : ""}</span>
                        </FormControl>
                      </Grid> : <></>
                  }
                  <Grid item xs={4}>
                    <FormControl
                      sx={{ m: 1 }}
                      fullWidth
                      required={required}
                      error={error}
                    >
                      <InputLabel htmlFor="history">History</InputLabel>
                      <Select
                        name="history"
                        label="history"
                        value={history}
                        disabled={mode === constants.MODE.view}
                        onChange={(event: any) => {
                          let v = event.target.value;
                          if (v !== extractorDetail?.hstgPattern?.selectedPatternId) {
                            setTechMetadataChanged(true);
                          }
                          setHistory(v);
                        }}
                        labelId="historyLabel"
                        fullWidth
                        onBlur={onHandleBlur}
                        required
                        sx={{ textAlign: "left" }}
                      >
                        {
                          mode === "Edit" ? patterns.HSTG !== undefined && patterns?.HSTG.filter((item: IExtractorPatterns) => {
                            if (connection === "S3 Buckets" || layerType === "EXTRACT_S3") { return item.patternName.includes("S3") }
                            else if (layerType === constants.EXTRACT_TYPES.adls) {
                              var azurePatterns = ["ADLS", "RIO-HSTG ADF Synapse Comparison Key"];
                              return azurePatterns.some(x => item.patternName.includes(x));
                            }
                            // else if (connection === "Windows Fileshare" || layerType === "EXTRACT_WFS") { return item.patternName.includes("ADF ADLS") }
                            else return item.patternName.includes("ADF Synapse")
                          }).map((item: IExtractorPatterns, index: number) => {
                            return (
                              <MenuItem key={index} value={item.etlPatternId}>{item.patternName}</MenuItem>
                            );
                          }) // adding the else condition so that it doesn't affect displaying patterns on existing extractors. can be removed after a while
                            : patterns.HSTG !== undefined && patterns?.HSTG.map((item: IExtractorPatterns, index: number) => {
                              return (
                                <MenuItem key={index} value={item.etlPatternId}>{item.patternName}</MenuItem>
                              );
                            })
                        }
                        <MenuItem value="-1" selected>None</MenuItem>
                      </Select>
                      <span style={errorStyle}>{error ? errorMsg : ""}</span>
                    </FormControl>
                  </Grid>{" "}
                </>
              )}
                {(

                  layerType === constants.EXTRACT_TYPES.windowsFileshare ||
                  layerType === constants.EXTRACT_TYPES.s3Buckets || layerType === constants.EXTRACT_TYPES.adls) && (
                    <Grid item xs={12}>
                    <h2>File Registrations</h2>
                    </Grid>
                  )}

              {/* if amazon s3 */}
                {layerType === constants.EXTRACT_TYPES.windowsFileshare ||
                  layerType === constants.EXTRACT_TYPES.s3Buckets || layerType === constants.EXTRACT_TYPES.adls ? (
                    <>
                      {
                        layerType !== constants.EXTRACT_TYPES.adls ? <>
                  <Grid item xs={3}>
                    <Picker
                      name="fileType"
                      label="File Type"
                      options={["CSV", "TSV", "AVRO"]}
                      value={configureTablesData.fileType.fieldValue}
                      error={configureTablesData.fileType.isError}
                      onChange={handleDropDownChange}
                    />
                          </Grid>
                          <Grid item xs={3}>
                        <FormControl sx={{ m: 1 }} fullWidth>
                          <DataField id="b08cd582-3236-429b-88e1-96f8921749d8"
                            label={connection === "Windows Fileshare" || layerType === "EXTRACT_WFS" ? "Path" : "Bucket Name"}
                            name="blobContainer"
                            value={configureTablesData.blobContainer.fieldValue}
                            error={configureTablesData.regex.isError}
                            onChange={handleChange}
                            readOnly={mode === constants.MODE.view}
                          />
                            </FormControl>
                          </Grid>
                          <Grid item xs={3}>
                            <FormControl sx={{ m: 1 }} fullWidth>
                              <InputLabel id="manifestFileFlag">
                                Manifest File Flag
                              </InputLabel>
                              <Select
                                labelId="manifestFileFlag"
                                label="manifestFileFlag"
                                id="manifestFileFlag"
                                name="manifestFileFlag"
                                disabled={mode === constants.MODE.view}
                                variant={
                                  mode === constants.MODE.view ? "standard" : "outlined"
                                }
                                onChange={onDropdownChange}
                                value={configureTablesData.manifestFileFlag.fieldValue}
                                fullWidth
                              >
                                <MenuItem key="0" value="TRUE">
                                  TRUE
                                </MenuItem>
                                <MenuItem key="1" value="FALSE">
                                  FALSE
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>
                          <Grid item xs={3}>
                    <DataField id="a0b33416-49fd-402a-9863-757b1c9b086d"
                      label="Regex"
                      name="regex"
                              value={configureTablesData.regex.fieldValue}
                      onChange={handleChange}
                    />
                  </Grid>
                        </> :
                          <></>
                      }
                      <Grid item xs={3}>
                        <FormControl sx={{ m: 1 }} fullWidth >
                          <InputLabel htmlFor="fieldDelimeter">
                            Delimeter
                          </InputLabel>
                          <Select
                            label="fieldDelimeter"
                            name="fieldDelimeter"
                            id="fieldDelimeter"
                            disabled={mode === constants.MODE.view}
                            variant={
                              mode === constants.MODE.view ? "standard" : "outlined"
                            }
                            onChange={onDropdownChange}
                            value={configureTablesData.fieldDelimeter.fieldValue}
                            defaultValue=","
                            fullWidth
                          >
                            <MenuItem key="0" value=",">
                              Comma (,)
                            </MenuItem>
                            <MenuItem key="1" value=";">
                              Semi-colon (;)
                            </MenuItem>
                            <MenuItem key='2' value='\t'>Tab (\t)</MenuItem>

                          </Select>
                        </FormControl>
                      </Grid>


                  <Grid item xs={3}>
                    <Picker
                      name="headerRows"
                      label="Header Rows"
                      options={["TRUE", "FALSE"]}
                          value={configureTablesData.headerRows.fieldValue}
                      onChange={handleDropDownChange}
                    />
                      </Grid>
                      {(layerType === constants.EXTRACT_TYPES.s3Buckets || layerType === constants.EXTRACT_TYPES.windowsFileshare
                        || layerType === constants.EXTRACT_TYPES.adls) && (
                          <>
                            <Grid item xs={3}>
                              {<FormControl sx={{ m: 1 }} fullWidth >
                                <InputLabel htmlFor='textDelimiter'>Text Delimiter</InputLabel>
                                <Select
                                  label='textDelimiter'
                                  name='textDelimiter'
                                  id='textDelimiter'
                                  disabled={mode === constants.MODE.view}
                                  variant={
                                    mode === constants.MODE.view ? "standard" : "outlined"
                                  }
                                  onChange={onDropdownChange}
                                  value={configureTablesData.textDelimiter.fieldValue}
                                  defaultValue='"'
                                  fullWidth
                                >
                                  <MenuItem key='0' value="&#39;" >Single-Quotes (')</MenuItem>
                                  <MenuItem key='1' value='"'>Double-Quotes (")</MenuItem>
                                </Select>


                              </FormControl>
                              }
                            </Grid>
                            <Grid item xs={3}>
                              {<FormControl sx={{ m: 1 }} fullWidth >
                                <InputLabel htmlFor='escapeChar'>Escape Char</InputLabel>
                                <Select
                                  label='escapeChar'
                                  name='escapeChar'
                                  id='escapeChar'
                                  disabled={mode === constants.MODE.view}
                                  variant={
                                    mode === constants.MODE.view ? "standard" : "outlined"
                                  }
                                  onChange={onDropdownChange}
                                  value={configureTablesData.escapeChar.fieldValue}
                                  defaultValue='"'
                                  fullWidth
                                >
                                  <MenuItem key='0' value="&#39;" >Single-Quotes (')</MenuItem>
                                  <MenuItem key='1' value='"'>Double-Quotes (")</MenuItem>
                                </Select>
                              </FormControl>
                              }

                            </Grid>
                            <Grid item xs={3}>
                              <FormControl sx={{ m: 1 }} fullWidth variant={(mode === constants.MODE.view) ? "standard" : "outlined"}>
                                <Picker
                                  name='deleteFiles'
                                  label='Delete Files'
                                  options={["Y", "N"]}
                                  value={configureTablesData.deleteFiles.fieldValue}
                                  disabled={mode === constants.MODE.view}
                                  readOnly={(mode === constants.MODE.view) ? true : false}
                                  onChange={onDropdownChange}
                                />
                              </FormControl>
                            </Grid>
                          </>
                        )}    

                  {/* Table */}
                  <Grid item xs={12}>
                    <h2>Import Fields</h2>

                    <p>
                      Define field-level attributes, data compliance treatments and
                      row level filters. This process is required*.
                    </p>
                    <Grid item xs={12}>

                      <AvroGenerator

                        avroCode={avroCode}
                        setAvroCode={setAvroCode}
                        getAvroCode={getAvroCode}
                      ></AvroGenerator>
                      <SqlGenerator
                        sqlCode={sqlCode}
                        setSqlCode={setSqlCode}
                        setColumnGovernance={setColumnGovernance}
                      ></SqlGenerator>
                    </Grid>
                  </Grid>
                </>
              ) : (
                <Grid item xs={12}>
                  <h2>Field Attributes </h2>
                  <p>
                    Define field-level attributes, data compliance treatments and
                    row level filters. This process is required*.
                  </p>
                  {mode === "Edit" ?
                    (<Grid item xs={12}>
                      <Box>
                        <Button color="primary" variant="contained" onClick={generateFieldsFromDB}>
                          Generate Fields from Database
                        </Button>
                      </Box>
                    </Grid>) : ("")}
                </Grid>
              )}

              {/* Table Data */}

              {columnGovernance ? (
                <Grid item xs={12}>
                  <Stack
                    spacing={2}
                    alignItems="flex-start"
                    style={{ width: "100%" }}
                  >
                    <Box
                      sx={{
                        width: "100%",
                        height: 400,
                        bgcolor: "background.paper",
                      }}
                    >
                      <DataGrid
                        pagination
                        onCellEditCommit={handleCommit}
                        rows={columnGovernance}
                        rowsPerPageOptions={[30, 50, 100]}
                        columns={[
                          {
                            field: "srcColumnName",
                            headerName: "Name (raw)",
                            width: 200,
                          },
                          {
                            field: "srcDataType",
                            headerName: "Type (raw)",
                            width: 120,
                          },
                          {
                            field: "srcMaxLength",
                            headerName: "Size (raw)",
                            width: 120,
                          },
                          {
                            field: "synColumnName",
                            headerName: "Name",
                            width: 120,
                          },
                          {
                            field: "synDataType",
                            headerName: "Type",
                            width: 120,
                          },
                          {
                            field: "synMaxLength",
                            headerName: "Size",
                            width: 120,
                          },
                          {
                            field: "treatmentLevel",
                            headerName: "Treatment",
                            width: 120,
                            editable: mode !== constants.MODE.view,
                            renderEditCell: renderTreatmentCell,
                            valueGetter: (params) => getTreatmentValue(params.row.securityClassification, params.row.privacyClassification),
                          },
                          {
                            field: "securityClassification",
                            headerName: "Security Classification",
                            width: 190,
                            editable: mode !== constants.MODE.view,
                            renderEditCell: renderSecurityCell,
                          },
                          {
                            field: "privacyClassification",
                            headerName: "Privacy Classification",
                            width: 190,
                            editable: mode !== constants.MODE.view,
                            renderEditCell: renderPrivacyCell,
                          },
                        ]}
                      />
                    </Box>
                  </Stack>
                </Grid>
              ) : (
                ""
              )}


              <Grid item xs={12}>
                <h2>Technical</h2>
              </Grid>

              {connection === "S3 Buckets" ||
                connection === "Windows Fileshare" ? (
                ""
              ) : (
                <Grid item xs={6}>
                  <DataField id="6f80ae11-f52d-4dff-a527-fe00f60b76e0"
                    type="textarea"
                    name="customsql"
                    label="Custom SQL"
                    // disabled={mode === "Edit" ? true : false}
                    multiline={true}
                    rows={3}
                    value={configureTablesData.customsql.fieldValue}
                    error={configureTablesData.customsql.isError}
                    onChange={
                      (event: {}) => {
                        const e = event as React.ChangeEvent<HTMLInputElement>;
                        if (e.currentTarget.value !== extractorDetail?.customSql) {
                          setTechMetadataChanged(true);
                        }
                        handleChange(event);
                      }
                    }
                  />
                </Grid>
              )}
              {columnGovernance ? <>
                <Grid item xs={6}>
                  <FormControl
                    sx={{ m: 1 }}
                    fullWidth
                    required={false}
                    error={error}
                  >
                    <InputLabel htmlFor="comparisonKeyLabel">
                      Comparison Keys
                    </InputLabel>
                    <Select
                      name="comparisonKey"
                      label="Comparison Key"
                      labelId="comparisonKeyLabel"
                      fullWidth
                      multiple
                      value={comparisonKey}
                      onChange={(event) => {
                        if (event.target.value.length > 0) {
                          let v = event.target.value as string[];
                          if (v.join(';') !== extractorDetail?.mappingAttributes) {
                            setTechMetadataChanged(true);
                          }
                          setComparisonKey(v.filter(Boolean));
                        }
                      }}
                      disabled={mode === constants.MODE.view}
                      sx={{ textAlign: "left" }}
                    >
                      {columnGovernance &&
                        columnGovernance.map((item: any, index: number) => {
                          return (
                            <MenuItem key={index} value={item.synColumnName.toUpperCase()}>
                              {item.synColumnName.toUpperCase()}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </FormControl>
                </Grid>
              </>
                : ''}

              {displaySchemaUpdateBtn ?
                (<Grid item xs={12}>
                  <Box>
                    <Button color="primary" variant="contained" onClick={updateSchema}>
                      Update Schema
                    </Button>
                  </Box>
                </Grid>) : <Grid item xs={12}>{updateSchemaPending ? <LoadingButton loading loadingPosition="start" variant="outlined" sx={{ m: 1 }} startIcon={<SaveIcon />} >Processing </LoadingButton> : <></>}</Grid>
              }
              {displayRetrySchemaBtn ?
                (<Grid item xs={12}>
                  <Button color="primary" variant="contained" onClick={retrySchemaUpdate}>
                    Retry Schema Update
                  </Button>
                </Grid>) : (retryUpdateSchemaPending ? <Grid item xs={12}><LoadingButton loading loadingPosition="start" variant="outlined" sx={{ m: 1 }} startIcon={<SaveIcon />} >Processing </LoadingButton> </Grid> : <></>)
              }

              {/* View Extractor Buttons */}
              {mode === constants.MODE.view ? (
                <Grid item xs={12}>
                  <Box
                    display="flex"
                    justifyContent="flex-start"
                    style={{ marginBottom: "1em" }}
                  >
                    <Button id="1b1ef3b1-2805-4526-94f3-69811b9b6c1a"
                      color="primary"
                      variant="contained"
                      onClick={runWorkflow}
                      sx={{ m: 1 }}
                    >
                      Run now
                    </Button>
                    <Button id="67c9ebe3-3396-4a6f-8695-65b4c8f12323"
                      color="primary"
                      variant="contained"
                      onClick={runRebase}
                      sx={{ m: 1 }}
                    >
                      Run now (rebase)
                    </Button>
                    <ExtractorStatus
                        batchCode={batchCode ? batchCode : ""}
                    ></ExtractorStatus>
                  </Box>
                </Grid>
              ) : (
                ""
              )}

              {/* Triggers */}
              <Grid item xs={12}>
                <>
                  <h2>Extraction</h2>
                  <p>
                    Tasks must be run manually unless a trigger is added to run
                    repeatedly.
                  </p>
                  <h3>Triggers</h3>
                  <p>Triggers for the task to commence.</p>
                </>

                <>
                  <ul>
                    {jobList &&
                      jobList.length > 0 &&
                      jobList?.map((job: any, index: number) => {
                        return (
                          <li key={index}>
                            {cronstrue.toString(job.cronExpression)} (UTC {job.timezone})
                            <IconButton
                              color="primary"
                              aria-label="time based list"
                              component="span"
                              onClick={() => editTimeTrigger(job)}
                            >
                              <EditIcon />
                            </IconButton>
                            <IconButton
                              color="primary"
                              aria-label="upload picture"
                              component="span"
                              onClick={() => setOpenTimeTrigger(true)}
                            >
                              <DeleteSharpIcon />
                            </IconButton>
                            <>
                              <CustomizedDialogs
                                dialogHeight=""
                                modalSize="md"
                                key="trigger"
                                modalTitle="Delete Confirmation"
                                isOpen={openTimeTrigger}
                                onClose={handleClose}
                                footerAction={
                                  <Stack direction="row" spacing={2}>
                                    <Button id="3c8b7e30-9d36-4363-826b-153c97c333fe"
                                      color="primary"
                                      onClick={() => handleJobDelete(job.id)}
                                      autoFocus
                                    >
                                      Yes
                                    </Button>
                                    <Button id="a79d1ce0-0a28-40f2-bf43-91f48f0b96fd"
                                      color="primary"
                                      onClick={handleClose}
                                    >
                                      No
                                    </Button>
                                  </Stack>
                                }
                              >
                                <>
                                  Are you sure you want to delete time based
                                  trigger?
                                </>
                              </CustomizedDialogs>
                            </>
                          </li>
                        );
                      })}
                    {eventList &&
                      eventList.length > 0 &&
                      eventList?.map((task: any, index: number) => {
                        return (
                          <li key={index}>
                            {" "}
                            {
                              task.eventType === "EXTRACT_TASK.SUCCESS"
                                  ? `Events: ${task.description ? task.description : 'No description'}`
                                  : `Inbound Webhook: ${AppConfig().BaseUrl}api/v1/webhooks/${task.eventQualifier}?type=extractor`
                            }
                            <IconButton
                              color="primary"
                              aria-label="event based list"
                              component="span"
                              onClick={() => editExtractor(task)}
                            >
                              <EditIcon />
                            </IconButton>
                            <IconButton
                              color="primary"
                              aria-label="upload picture"
                              component="span"
                              onClick={() => setOpen(true)}
                            >
                              <DeleteSharpIcon />
                            </IconButton>
                            <>
                              <CustomizedDialogs
                                dialogHeight=""
                                modalSize="md"
                                key="target"
                                modalTitle="Delete Confirmation"
                                isOpen={open}
                                onClose={handleClose}
                                footerAction={
                                  <Stack direction="row" spacing={2}>
                                    <Button id="d9931b8c-4135-4948-a34e-db7ede75dede"
                                      color="primary"
                                      onClick={() =>
                                        handleExtractorDelete(task.id)
                                      }
                                      autoFocus
                                    >
                                      Yes
                                    </Button>
                                    <Button id="1918a916-bae5-4823-b6b3-4f07d3cd5650"
                                      color="primary"
                                      onClick={handleClose}
                                    >
                                      No
                                    </Button>
                                  </Stack>
                                }
                              >
                                <>
                                  Are you sure you want to delete the trigger ?
                                </>
                              </CustomizedDialogs>
                            </>
                          </li>
                        );
                      })}
                  </ul>
                </>

                <>
                  <Box
                    display="flex"
                    justifyContent="flex-start"
                    style={{ marginBottom: "1em" }}
                  >
                    <Button id="577692d6-010e-4acf-b545-acdbe794f1c3"
                      color="primary"
                      variant="contained"
                      onClick={addTrigger}
                    >
                      Add New{" "}
                    </Button>
                  </Box>
                  <div>
                    {triggers.map((trigger: any) => (
                      <React.Fragment key={trigger.key}>
                        {trigger.key !== 0 ?
                          <Box
                            sx={{
                              border: 1,
                              borderColor: "divider",
                              padding: 2,
                              width: "100%",
                              display: "block",
                            }}
                          >
                            <Grid container spacing={5} alignItems="center">
                              <TriggerRow
                                value={trigger}
                                onChange={onTriggerChange}
                                type={'extractor'}
                              />
                              <p></p>
                              <Grid item xs={1}>
                                <IconButton
                                  color="primary"
                                  aria-label="upload picture"
                                  component="span"
                                  onClick={() => deleteTrigger(trigger.key)}
                                >
                                  <DeleteSharpIcon />
                                </IconButton>
                              </Grid>
                            </Grid>
                          </Box>
                          : <></>}
                      </React.Fragment>
                    ))}
                  </div>
                </>
              </Grid>
              <Grid item xs={12}>
                <h2>Actions</h2>
                <p>
                  Actions to take once the task has successfully completed.{" "}
                </p>
                <h3>
                  Outbound Webhooks{" "}
                  <Tooltip title="Once the task runs successfully, a message will be sent via an API/webhook">
                    <IconButton>
                      <InfoIcon />
                    </IconButton>
                  </Tooltip>
                </h3>
                {outbound &&
                  outbound.length > 0 &&
                  outbound.map((task: any, index: number) => {
                    return (
                      <li key={index}>
                        {" "}
                        Webhook:{" "}
                        {task.eventActionValue ? task.eventActionValue : ""} {task.outboundWebhookHeader ? ` - ${task.outboundWebhookHeader}` : ''}
                        <IconButton
                          color="primary"
                          aria-label="edit extrigger"
                          component="span"
                          onClick={() => editOutbound(task)}
                        >
                          <EditIcon />
                        </IconButton>
                        <IconButton
                          color="primary"
                          aria-label="upload picture"
                          component="span"
                          onClick={() => setOpenOutbound(true)}
                        >
                          <DeleteSharpIcon />
                        </IconButton>
                        <>
                          <CustomizedDialogs
                            dialogHeight=""
                            modalSize="md"
                            key="target"
                            modalTitle="Delete Confirmation"
                            isOpen={openOutbound}
                            onClose={handleClose}
                            footerAction={
                              <Stack direction="row" spacing={2}>
                                <Button id="b2e56a4b-ed76-44be-ab31-29c97d9d968c"
                                  color="primary"
                                  onClick={() => handleOutboundDelete(task.id)}
                                  autoFocus
                                >
                                  Yes
                                </Button>
                                <Button id="f9ad53f9-6346-4bdb-8d35-1a71b83967af" color="primary" onClick={handleClose}>
                                  No
                                </Button>
                              </Stack>
                            }
                          >
                            <>
                              Are you sure you want to delete outbound webhook?
                            </>
                          </CustomizedDialogs>
                        </>
                      </li>
                    );
                  })}
                {mode === constants.MODE.view ? (
                  ""
                ) : (
                  <>
                    <Box
                      display="flex"
                      justifyContent="flex-start"
                      style={{ marginBottom: "1em" }}
                    >
                      <Button id="9a7a0f6f-af16-4d1a-b9d3-8f77ecfd1c40"
                        color="primary"
                        variant="contained"
                        onClick={addAction}
                      >
                        Add New{" "}
                      </Button>
                    </Box>
                    <div>
                      {actions.map((actionItem) => (
                        <React.Fragment key={actionItem.key}>
                          <Box
                            sx={{
                              border: 1,
                              borderColor: "divider",
                              padding: 2,
                              width: "100%",
                              display: "block",
                            }}
                          >
                            <Grid container spacing={5} alignItems="center">
                              <ActionRow
                                value={actionItem}
                                onChange={onActionChange}
                              />
                              <Grid item xs={1}>
                                <IconButton
                                  color="primary"
                                  aria-label="upload picture"
                                  component="span"
                                  onClick={() => deleteAction(actionItem.key)}
                                >
                                  <DeleteSharpIcon />
                                </IconButton>
                              </Grid>
                            </Grid>
                          </Box>
                        </React.Fragment>
                      ))}
                    </div>
                  </>
                )}
              </Grid>

              {/*  Edit button */}
              {mode === "Edit" ? (<>
                <Grid item xs={12}>
                  <Box display="flex" justifyContent="flex-end">
                    <Button id="50056fd0-afae-44a4-97ad-5a6327e529e7"

                      variant="contained"
                      onClick={goBack}
                      style={{ marginRight: "1em", marginTop: "1em" }}
                    >
                      Cancel
                    </Button>
                    {(pending || pendingMetadata) && loader ? (
                      <>
                        <ProgressPopup open={true} message="Update" />
                        <LoadingButton
                          loading
                          loadingPosition="start"
                          variant="outlined"
                          startIcon={<SaveIcon />}
                          size="small"
                        >
                          Processing
                        </LoadingButton>{" "}
                      </>
                    ) : (
                      <Button id="0983c1f0-5ffd-46ec-9a4a-2d15e085ebfd"
                        variant="contained"
                        style={{ marginTop: "1em" }}
                        onClick={validateForm}
                        disabled={displayUpdateEXTBtn}
                      >
                        Update Extractor
                      </Button>
                    )}
                    <Button id="viewEXT"
                      variant="contained"
                      onClick={viewExtractor}
                      style={{ marginLeft: "1em", marginTop: "1em" }}
                    >
                      View Extractor
                    </Button>
                  </Box>
                </Grid>
              </>
              ) : (
                ""
              )}

              {mode !== "Add" ? (
                <>
                  <Grid item xs={6}>
                    <Box display="flex" justifyContent="flex-start">
                      Last Updated By: {lastUpdated}
                    </Box>
                    <Box display="flex" justifyContent="flex-start">
                      Last Modified On: {lastModified}
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box display="flex" justifyContent="flex-end">
                      Created By: {createdBy}
                    </Box>
                    <Box display="flex" justifyContent="flex-end">
                      Created On: {createdOn}
                    </Box>
                  </Grid>
                </>
              ) : (
                ""
              )}
            </Grid>
          )}
        </Form>
      </div>
    </Formik>
  );
};
// creating a privacy cell
const renderPrivacyCell = (params: any) => {
  return <SelectPrivacyCell {...params} />;
};

function SelectPrivacyCell(props: any) {
  const { id, value, field } = props;
  const apiRef = useGridApiContext();

  cellEnablePrivacy = props.row.securityClassification === "Confidential";

  const handleChange = async (event: any) => {
    await apiRef.current.setEditCellValue({
      id,
      field,
      value: event.target.value,
    });
  };

  return (
    <Select
      value={value}
      onChange={handleChange}
      size="small"
      sx={{ height: 1 }}
      native
      autoFocus
    >
      <option value="" disabled selected>
        Select
      </option>
      <option value={constants.PRIVACY_CLASS.none}>{constants.PRIVACY_CLASS.none}</option>
      <option disabled={!cellEnablePrivacy} value={constants.PRIVACY_CLASS.personal}>{constants.PRIVACY_CLASS.personal}</option>
      <option disabled={!cellEnablePrivacy} value={constants.PRIVACY_CLASS.sensitive}>{constants.PRIVACY_CLASS.sensitive}</option>
    </Select>
  );
}

// creating a security cell
const renderSecurityCell = (params: any) => {
  return <SelectSecurityCell {...params} />;
};

function SelectSecurityCell(props: any) {
  const { id, value, field } = props;
  const apiRef = useGridApiContext();

  const handleChange = async (event: SelectChangeEvent<any>) => {
    await apiRef.current.setEditCellValue({
      id,
      field,
      value: event.target.value,
    });
  };


  return (
    <Select
      value={value}
      onChange={handleChange}
      size="small"
      sx={{ height: 1 }}
      native
      autoFocus
    >
      <option value="none" disabled selected>
        Select
      </option>
      <option value={constants.SECURITY_CLASS.general}>{constants.SECURITY_CLASS.general}</option>
      <option value={constants.SECURITY_CLASS.confidential}>{constants.SECURITY_CLASS.confidential}</option>
      <option value={constants.SECURITY_CLASS.highlyConfidential}>{constants.SECURITY_CLASS.highlyConfidential}</option>
    </Select>
  );
}

// creating a treatment cell
const renderTreatmentCell = (params: any) => {
  return <SelectTreatmentCell {...params} />;
};

function SelectTreatmentCell(props: any) {
  const { id, value, field } = props;
  const apiRef = useGridApiContext();

  const handleChange = async (event: any) => {
    await apiRef.current.setEditCellValue({
      id,
      field,
      value: event.target.value,
    });
  };

  return (
    <Select
      value={value}
      onChange={handleChange}
      size="medium"
      sx={{ height: 80 }}
      native
      autoFocus
    >
      <option value="None" disabled selected>
        Select
      </option>
      {allowLowTreatment && <option value="Low">Low</option>}
      {allowMediumTreatment && <option value="Medium">Medium</option>}
      {allowHighTreatment && <option value="High">High</option>}
    </Select>
  );
}

//Setting treatment at Row Level
const getTreatmentValue = (security: string, privacy: string) => {
  if (security === 'Highly Confidential') {
    allowLowTreatment = false;
    allowMediumTreatment = false;
    return 'high';
  } else if (security === 'Confidential') {
    allowLowTreatment = false;
    if (privacy === 'None') {
      allowLowTreatment = false;
      allowMediumTreatment = true;
      return 'medium';
    } else if (privacy === 'Personal Data') {
      allowLowTreatment = false;
      allowMediumTreatment = false;
      return 'high';
    } else if (privacy === 'Sensitive Data') {
      allowLowTreatment = false;
      allowMediumTreatment = false;
      allowHighTreatment = false;
      return 'very-high';
    }
  }
  else {
    allowLowTreatment = true;
    allowMediumTreatment = true;
    allowHighTreatment = true;
    return 'low';
  }
}

export default EditExtractorForm;